
import { Box } from '@mui/material';
import { products } from '../../constants/productConstant';
import Airpod from './Airpod';

import Product from './Product';
import TV from './TV';

const Products = () => {
    return (
        <>
            <Box style={{display:'flex'}}>
                <Product data={products.watch} />
                <Product data={products.ipad} />
            </Box>
            <Box style={{display:'flex'}}>
                <Airpod data={products.airprods} />
                <Product data={products.homepod} />
            </Box>
            <Box style={{display:'flex'}}>
                <Product data={products.arcade} />
                <TV data={products.appletv} />
            </Box>
        </>
    )
}

export default Products;